import apiClient from './ApiService'

export default {
  getTerritoriales(page = 1, limit = 100, filters = {}) {
    return apiClient.get('/territoriales', {
      params: {
        page,
        limit,
        ...filters
      }
    })
  },
  
  getAllTerritoriales() {
    return apiClient.get('/territoriales/all')
  },
  
  getTerritorial(id) {
    return apiClient.get(`/territoriales/${id}`)
  },
  
  createTerritorial(territorial) {
    return apiClient.post('/territoriales', territorial)
  },
  
  updateTerritorial(id, territorial) {
    return apiClient.put(`/territoriales/${id}`, territorial)
  },
  
  deleteTerritorial(id) {
    return apiClient.delete(`/territoriales/${id}`)
  }
}